import { render, staticRenderFns } from "./TimeTplList.vue?vue&type=template&id=5c4f52df&scoped=true&"
import script from "./TimeTplList.vue?vue&type=script&lang=js&"
export * from "./TimeTplList.vue?vue&type=script&lang=js&"
import style0 from "./TimeTplList.vue?vue&type=style&index=0&id=5c4f52df&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4f52df",
  null
  
)

export default component.exports